<template>
  <VpConfirmModal :modalId="'deleteAnnouncementConfirmModal'">
    <template v-slot:title>
      <span>{{ $t('announcements.deleteAnnouncement') }}</span>
    </template>

    <template v-slot:text1>
      <span>{{ $t('common.notes.areYouSureYouWant') }} <strong>"{{ $t('common.delete') }}"</strong> {{ $t('common.notes.this') }} {{ $t('announcements.form.announcement') }} {{ $t('common.questionMark') }}</span>
    </template>

    <template v-slot:buttons>
      <VpButton :text="$t('common.cancel')" @click="$bvModal.hide('deleteAnnouncementConfirmModal')" />
      <VpButton :text="$t('common.delete')" :disabled="submitted" :isDanger="true" @click="onSubmit()" />
    </template>
  </VpConfirmModal>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "deleteAnnouncementConfirmModal",
    data() {
      return {
        announcementId : null,
        isSubmitted : false,
      };
    },
    computed: {
      ...mapGetters("users", ["getModalState"]),
      ...mapGetters("modal", ["getModalInfo"]),
    },
    methods: {
      ...mapActions("announcements", ["deleteAnnouncement"]),
      onSubmit() {
        this.isSubmitted = true;
        this.deleteAnnouncement(this.announcementId).then(()=>{
          this.$emit('deleteAnnouncementEvent', this.announcementId);
          this.$bvModal.hide("deleteAnnouncementConfirmModal");
        });
      },
    },
    watch: {
      getModalState(state) {
        state && this.$bvModal.hide("deleteAnnouncementConfirmModal");
      },
    },
    beforeMount(){
      console.log('this.getModalInfo', this.getModalInfo);
      this.announcementId = this.getModalInfo;
    },
    destroyed(){
      this.isSubmitted = false;
      this.announcementId = null;
    }
  };
</script>